import { Card, CardContent, Typography, Box, Chip } from "@mui/material";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import StarOutlineRoundedIcon from "@mui/icons-material/StarOutlineRounded";
import styles from "./FeedbackHighlightsCard.module.scss";
import { useTranslation } from "react-i18next";

const StarRow = ({ rating }) => {
    const full = Math.floor(rating);
    const empty = 5 - full;
    return (
        <span className={styles.starRow}>
            {Array.from({ length: full }).map((_, i) => (
                <StarRoundedIcon key={`f-${i}`} className={styles.starIcon} />
            ))}
            {Array.from({ length: empty }).map((_, i) => (
                <StarOutlineRoundedIcon key={`e-${i}`} className={styles.starIcon} />
            ))}
        </span>
    );
};

const FeedbackItem = ({ name, rating, tag, text, t }) => {
    const orderTypeMap = {
        D: "Delivery",
        P: "Pickup",
        M: "Mixed",
        SR: "Service",
    };

    const displayTag = orderTypeMap[tag] || tag || "";

    return (
        <div className={styles.feedbackItem}>
            <div className={styles.feedbackIndicator} />
            <div className={styles.feedbackContent}>
                <div className={styles.feedbackHeader}>
                    <div className={styles.feedbackNameRating}>
                        <Typography variant="subtitle2" className={styles.feedbackName}>
                            {name}
                        </Typography>
                        <StarRow rating={rating} />
                    </div>

                    <Chip
                        label={displayTag}
                        className={styles.feedbackTag}
                    />
                </div>

                <Typography variant="body2" className={styles.feedbackText}>
                    {`"${text}"`}
                </Typography>
            </div>
        </div>
    );
};

const FeedbackHighlightsCard = ({ highlights = [] }) => {
    const { t } = useTranslation();
    if (!Array.isArray(highlights) || highlights.length === 0) return null;

    return (
        <Card className={styles.feedbackCard}>
            <CardContent className={styles.feedbackCardContent}>
                <Typography variant="subtitle3" className={styles.feedbackTitle}>
                    {t("reports.patientSurveyReportPage.feedback.highlightsTitle")}
                </Typography>

                <div className={styles.feedbackList}>
                    {highlights.map((it, i) => (
                        <FeedbackItem
                            key={i}
                            name={it.respondent || ""}
                            rating={it.rating || 0}
                            tag={(it.orderType || it.order_type || "").toString().trim().toUpperCase()}
                            text={it.comment || ""}
                            t={t}
                        />
                    ))}
                </div>
            </CardContent>
        </Card>
    );
};

export default FeedbackHighlightsCard;
